<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Fontodi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Acclamato da James Suckling come “il campione del Sangiovese”, sarebbe difficile trovarne uno cattivo
                        recensione di Fontodi. Sono uno dei produttori di vino rosso preferiti in Italia e del Chianti Classico
                        preferito da molti critici. Robert Parker ha conferito al 2006 lo status di "straordinario". Jancis
                        Robinson è un fan che ha "amato" il 2015 e gli ha dato 17/20. Tutte le annate segnano costantemente nel
                        medio-alti anni '90. Quindi dobbiamo chiederci: il Fontodi è all'altezza del suo clamore?
                    </div>

                    <div class="howto-title2">L'eredità toscana nel loro DNA</div>
                    <div class="howto-text">
                        Alla fine degli anni '60 la famiglia Manetti rileva la conduzione dei vigneti e della tenuta Fondoti,
                        deviando dall'attività di terracotta della loro famiglia (le piastrelle di Fontodi vengono utilizzate per restaurare
                        Duomo di Firenze. Si possono trovare anche nella sala Botticelli agli Uffizi.) La tenuta è
                        35 ettari, di cui 10 a Panzano. Nel 1979 Dino Manetti chiese ai figli Giovanni e
                        Marco, allora di soli 16 e 19 anni, ad assumere la direzione della vigna e della cantina. Sotto il
                        sotto la guida del noto consulente Franco Bernabei, i ragazzi gestirono insieme la tenuta mentre
                        il loro padre continuava l'azienda di piastrelle. Vent'anni dopo e le due aziende hanno
                        fuse, e oggi i vini vengono invecchiati in bellissimi vasi di argilla conosciuti come anfore. Il primo di Giovanni
                        vendemmia in anfora di Sangiovese in purezza, vino senza solfiti è stato fatto nel 2012. Lo ha chiamato “Dino”
                        dopo suo padre.
                    </div>

                    <div class="howto-title2">Semplice ma estremamente buono</div>
                    <div class="howto-text">
                        Tuttavia, il re di tutti i loro Chianti è senza dubbio il Flaccianello e considerato da
                        molti collezionisti come uno dei migliori vini investibili in Toscana. Questo perché, da un
                        Dal punto di vista degli investimenti, la gamma di Chianti Classico di Fontodi non perde mai il bersaglio. E da quello
                        intendiamo mai. Mentre molti Classici possono sembrare anonimi, Fontodi va avanti con il suo equilibrio
                        di frutta matura ma fresca e una sapidità che caratterizza un buon Chianti Classico. I tannini morbidi
                        favoriscono un lungo invecchiamento, che a sua volta offre un ampio appeal sul mercato. Relativamente economico per a
                        buon vino di questa qualità (circa € 100 a bottiglia anche se alcune delle annate migliori
                        sono più vicini a € 150) la crescita del mercato è relativamente lenta ma, come tutti gli altri aspetti di questo
                        produttore, costante.
                        <br><br>
                        Il mercato interno di Fontodi rappresenta il 23% delle vendite ma il loro mercato di esportazione è enorme: 77% in
                        130 paesi diversi. Gli Stati Uniti restano al primo posto con il 33%, seguiti dalla Germania con il 12%, il Canada con l'8% (il
                        crescita più rapida), 5% Scandinavia, 4% Regno Unito, 3% Giappone, 3% Svizzera.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Fontodi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Von James Suckling als „Champion des Sangiovese“ gepriesen, ist es schwer, etwas Schlechtes zu finden
                        Rezension von Fontodi. Sie sind einer der beliebtesten Rotweinproduzenten Italiens und des Chianti Classico
                        von vielen Kritikern bevorzugt. Robert Parker verlieh dem Jahr 2006 den Status „außergewöhnlich“. Jancis
                        Robinson ist ein Fan, der das Jahr 2015 „geliebt“ hat und ihm 17/20 gegeben hat. Alle Jahrgänge punkten durchweg
                        mittelhohe 90er Jahre. Wir müssen uns also fragen: Wird der Fontodi seinem Hype gerecht?
                    </div>

                    <div class="howto-title2">Toskanisches Erbe in ihrer DNA</div>
                    <div class="howto-text">
                        Ende der 1960er Jahre übernahm die Familie Manetti die Leitung der Weinberge und des Weinguts Fondoti.
                        Abweichung vom Terrakottafliesengeschäft ihrer Familie (Fontodi-Fliesen werden zur Restaurierung verwendet).
                        Der Dom von Florenz. Sie sind auch im Botticelli-Saal in den Uffizien zu finden.) Der Nachlass ist
                        35 Hektar, davon 10 Hektar in Panzano. 1979 fragte Dino Manetti seine Söhne Giovanni und
                        Marco, damals gerade 16 und 19 Jahre alt, übernimmt die Leitung des Weinbergs und der Kellerei. Unter dem
                        Unter der Leitung des renommierten Beraters Franco Bernabei verwalteten die Jungs das Anwesen währenddessen gemeinsam
                        Ihr Vater führte die Fliesenfirma weiter. Zwanzig Jahre später haben die beiden Unternehmen es geschafft
                        verschmolzen, und heute reifen die Weine in wunderschönen Tongefäßen, sogenannten Amphoren. Giovannis erster
                        Im Jahr 2012 wurde ein Amphoren-Jahrgang aus reinem, sulfitfreiem Sangiovese-Wein hergestellt. Er nannte ihn „Dino“.
                        nach seinem Vater.
                    </div>

                    <div class="howto-title2">Einfach, aber überaus gut</div>
                    <div class="howto-text">
                        Der König aller ihrer Chiantis ist jedoch zweifellos der Flaccianello und gilt als der von ihnen
                        vielen Sammlern gilt er als einer der besten investierbaren Weine der Toskana. Dies liegt daran, dass von einem
                        Aus Investitionssicht verfehlt Fontodis Angebot an Chianti Classicos nie das Ziel. Und damit
                        wir meinen nie. Während viele Classicos anonym erscheinen können, strebt Fontodi mit seiner Ausgewogenheit nach vorne
                        von reifen, aber frischen Früchten und einer Würze, die typisch für einen feinen Chianti Classico ist. Die weichen Tannine
                        sorgen für eine lange Reifung, die wiederum eine breite Marktattraktivität bietet. Relativ günstig für einen
                        feiner Wein dieser Qualität (ca. 100 € pro Flasche, obwohl einige der besseren Jahrgänge
                        liegen eher bei 150 €) Das Marktwachstum ist relativ langsam, aber wie alle anderen Aspekte auch
                        Produzent, Konstante.
                        <br><br>
                        Der Inlandsmarkt von Fontodi macht 23 % des Umsatzes aus, aber der Exportmarkt ist riesig: 77 % in
                        130 verschiedene Länder. Die USA bleiben mit 33 % die Nummer eins, gefolgt von Deutschland mit 12 % und Kanada mit 8 %
                        am stärksten wachsend), 5 % Skandinavien, 4 % Großbritannien, 3 % Japan, 3 % Schweiz.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Fontodi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Salué par James Suckling comme étant "le champion du Sangiovese", il serait difficile de trouver un mauvais
                        critique de Fontodi. Ils sont l'un des producteurs de vin rouge préférés d'Italie et le Chianti Classico
                        de préférence pour de nombreux critiques. Robert Parker a donné le statut "extraordinaire" 2006. Jancis
                        Robinson est un fan qui a « adoré » le 2015 et lui a donné 17/20. Tous les millésimes obtiennent un score constant dans le
                        mi-haut des années 90. Nous devons donc nous demander - le Fontodi est-il à la hauteur de son battage médiatique ?
                    </div>

                    <div class="howto-title2">L'héritage toscan dans leur ADN</div>
                    <div class="howto-text">
                        La famille Manetti a repris l'exploitation des vignes et du domaine Fondoti à la fin des années 1960,
                        déviant de l'entreprise familiale de carreaux de terre cuite (les carreaux de Fontodi sont utilisés pour restaurer
                        Le Duomo de Florence. On les trouve également dans la salle Botticelli aux Offices.) Le domaine est
                        35 hectares, dont 10 hectares à Panzano. En 1979, Dino Manetti demande à ses fils Giovanni et
                        Marco, alors âgé de seulement 16 et 19 ans, pour reprendre la direction du vignoble et du chai. Sous le
                        sous la direction du célèbre consultant Franco Bernabei, les garçons ont géré le domaine ensemble tout en
                        leur père a continué l'entreprise de tuiles. Vingt ans plus tard et les deux entreprises ont
                        fusionnés, et aujourd'hui les vins sont vieillis dans de beaux vases en argile appelés amphores. Le premier de Giovanni
                        une cuvée d'amphores de pur Sangiovese, un vin sans sulfite a été élaboré en 2012. Il l'a nommé "Dino"
                        après son père.
                    </div>

                    <div class="howto-title2">Simple mais extrêmement bon</div>
                    <div class="howto-text">
                        Cependant, le roi de tous leurs Chiantis est incontestablement le Flaccianello et considéré par
                        de nombreux collectionneurs comme l'un des meilleurs vins à investir en Toscane. C'est parce que, d'un
                        du point de vue de l'investissement, la gamme de Chianti Classicos de Fontodi ne rate jamais la cible. Et par là
                        nous voulons dire jamais. Alors que de nombreux Classico peuvent sembler anonymes, Fontodi avance à grands pas avec son équilibre
                        de fruits mûrs mais frais et un piquant qui caractérise un bon Chianti Classico. Les tanins souples
                        faire pour un long vieillissement, qui à son tour offre un large attrait sur le marché. Relativement bon marché pour un
                        vin fin de cette qualité (environ 100 € la bouteille bien que certains des meilleurs millésimes
                        sont plus proches de 150 €) la croissance du marché est relativement lente mais, comme tous les autres aspects de ce
                        producteur, constante.
                        <br><br>
                        Le marché domestique de Fontodi représente 23% des ventes mais leur marché à l'export est énorme : 77% en
                        130 pays différents. Les USA restent numéro un avec 33% suivis de l'Allemagne 12%, du Canada 8% (le
                        croissance la plus rapide), 5 % Scandinavie, 4 % Royaume-Uni, 3 % Japon, 3 % Suisse.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Fontodi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Hailed by James Suckling as being “the champion of Sangiovese”, it would be hard to find a bad
                        review of Fontodi. They are one of Italy’s favourite red wine producers and the Chianti Classico
                        of preference for many a critic. Robert Parker gave the 2006 “extraordinary” status. Jancis
                        Robinson is a fan who “loved” the 2015 and gave it 17/20. All vintages score consistently in the
                        mid-high 90s. So we have to ask - does the Fontodi live up to its hype?
                    </div>

                    <div class="howto-title2">Tuscan heritage in their DNA</div>
                    <div class="howto-text">
                        The Manetti family took over running of the Fondoti vineyards and estate in the late 1960s,
                        deviating from their family’s terracotta tile business (Fontodi tiles are being used to restore
                        Florence’s Duomo. They can also be found in the Botticelli room in the Uffizi.) The estate is
                        35-hectares, with 10-hectares in Panzano. In 1979 Dino Manetti asked his sons Giovanni and
                        Marco, then aged just 16 and 19, to take over running the vineyard and winery. Under the
                        guidance of renowned consultant Franco Bernabei, the boys managed the estate together whilst
                        their father was continued the tile company. Twenty years later and the two businesses have
                        fused, and today wines are aged in beautiful clay vases known as amphorae. Giovanni’s first
                        amphorae vintage of pure Sangiovese, sulphite-free wine was made in 2012. He named it “Dino”
                        after his father.
                    </div>

                    <div class="howto-title2">Simple but exceedingly good</div>
                    <div class="howto-text">
                        However, the king of all their Chiantis is unquestionably the Flaccianello and considered by
                        many collectors as one of the best investible wine in Tuscany. This is because, from an
                        investment point of view, Fontodi’s range of Chianti Classicos never miss the mark. And by that
                        we mean never. While many Classico’s can seem anonymous, Fontodi strides ahead with its balance
                        of ripe but fresh fruit and a tanginess that typifies a fine Chianti Classico. The soft tannins
                        make for long ageing, which in turn offer a broad market appeal. Relatively inexpensive for a
                        fine wine of this quality (approximately €100 per bottle although some of the better vintages
                        are closer to €150) market growth is relatively slow but, like all the other aspects of this
                        producer, constant.
                        <br><br>
                        Fontodi’s domestic market represents 23% of sales but their export market is enormous: 77% in
                        130 different countries. USA remains number one with 33% followed by Germany 12%, Canada 8% (the
                        fastest growing), 5% Scandinavia, 4% UK, 3% Japan, 3% Switzerland.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Fontodi",
    head: {
        title: 'Fontodi | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover Fontodi, a renowned Tuscany wine producer known for crafting premium quality wines using traditional techniques and local grape varieties. Experience the rich flavors and elegant aromas of Chianti Classico and other Tuscan wines from Fontodi.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
